// src/utils/api.js
import axios from 'axios';
import { store } from '../redux/store';
import { logout } from '../redux/slices/authSlice';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://perkexchange-production.up.railway.app/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Set auth token if it exists in localStorage
const token = localStorage.getItem('token');
if (token) {
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

// Add request interceptor to always check for token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for auth error handling
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Handle auth errors
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      // Check if we have a token in localStorage
      const token = localStorage.getItem('token');
      if (token) {
        // If we have a token but got a 401, the token is probably invalid
        localStorage.removeItem('token');
        store.dispatch(logout());
      }
      return Promise.reject(error);
    }

    // Handle rate limiting with exponential backoff
    if (error.response?.status === 429 && (!originalRequest._retryCount || originalRequest._retryCount < 3)) {
      originalRequest._retryCount = (originalRequest._retryCount || 0) + 1;
      const backoffTime = 1000 * Math.pow(2, originalRequest._retryCount); // 2s, 4s, 8s backoff
      await new Promise(resolve => setTimeout(resolve, backoffTime));
      return api(originalRequest);
    }

    return Promise.reject(error);
  }
);

export default api;